var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Bind.Mobilephone",
    "options": {
        "objc_class_prefix": "BindMobilephone",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "mobilephone",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "smsCode",
                    "id": 2
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/mall/withdraw/bindphone.pb.js